module.exports = __webpack_public_path__ + "static/media/render.f2aa8461.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/createReactApp/render.png
// module id = 54
// module chunks = 0